import { RouteObject } from 'react-router';
import { About, AccountManagement, Preferences, ProfileEdit } from '../components';

export const SharedSettingsRoutes: RouteObject[] = [
  { path: 'profile', element: <ProfileEdit /> },
  { path: 'preferences', element: <Preferences /> },
  { path: 'account-management', element: <AccountManagement /> },
  { path: 'about', element: <About /> }
];
